<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="properties"
        >
          <div
            v-for="i in scope.row.properties"
            :key="i.index"
          >{{i.skuKey}}:{{i.skuValue}}</div>
        </template>
        <!-- <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
        </template> -->
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
         <!--  <el-button
            type="primary"
            icon="el-icon-tickets"
            size="small"
            plain
            @click.stop="downloadExcelLog"
          >导出Excel</el-button> -->
          <el-button
            type="primary"
            icon="el-icon-printer"
            size="small"
            plain
            @click.stop="printJson()"
          >打印</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="constituteForm"
        >
          <div>
            <el-table
              :data="constitutes"
              border
            >
              <template v-for="(col,index) in tableData1">
                <el-table-column
                  sortable
                  :show-overflow-tooltip="true"
                  :prop="col.dataItem"
                  :label="col.dataName"
                  :key="col.dataItem"
                  width="124px"
                >
                  <template slot-scope="scope">
                    <el-input
                      type="input"
                      :name="col.dataName"
                      v-model="scope.row[index]"
                      :placeholder="col.placeholder"
                    ></el-input>
                  </template>
                </el-table-column>
              </template>

              <el-table-column
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-check"
                    size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div style="margin-top: 20px">
              <el-button @click="handleAddRows()">增加一行</el-button>
            </div> -->
          </div>
        </template>
        <template
          slot-scope="scope"
          slot="brandNameForm"
        >
          <el-select
            v-model="brand"
            placeholder="请选择品牌"
            required
            value-key="id"
          >
            <el-option
              v-for="brand in brands"
              :key="brand.id"
              :label="brand.name"
              :value="brand.id"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="firstClassifyNameForm"
        >
          <el-select
            v-model="classify"
            placeholder="一级分类"
            required
            disabled
            @change="chooseSecondClassify"
            value-key="id"
          >
            <el-option
              v-for="classify in classifies"
              :key="classify.id"
              :label="classify.name"
              :value="classify"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="secondClassifyNameForm"
        >
          <el-select
            v-model="secondClassify"
            placeholder="二级分类"
            disabled
            required
            @change="findProductSkuClassify"
            value-key="id"
          >
            <el-option
              v-for="secondClassify in secondClassifies"
              :key="secondClassify.id"
              :label="secondClassify.name"
              :value="secondClassify"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="skuForm"
        >
          <el-select
            v-model="sku"
            placeholder="请选择SKU组合"
            disabled
            required
            @change="findConstituteBySkuId"
            value-key="id"
          >
            <el-option
              v-for="sku in skuList"
              :key="sku.id"
              :label="sku.skuName"
              :value="sku"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="productStatusForm"
        >
          <div>
            <el-radio
              v-model="productStatus"
              label="PUTAWAY"
            >上架</el-radio>
            <el-radio
              v-model="productStatus"
              label="UNDERCARIAGE"
            >下架</el-radio>
          </div>
        </template>
        <template
          slot-scope="scope"
          slot="describeImgsForm"
        >
          <el-upload
            :multiple="true"
            action="#"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList"
            :http-request="fnUploadDescribeImgs"
            :show-file-list="false"
          >
            <div
              v-if="'' != describeImgs"
              class="el-upload el-upload--picture-img"
            >
              <div
                :key="describeImg.id"
                v-for="describeImg of describeImgs"
              >
                <img
                  :src="describeImg"
                  style="width: 200px;"
                />
                <a
                  style="margin-left: 20px"
                  @click.stop="deleteDes(describeImg)"
                >删除</a>
              </div>
            </div>

            <div
              v-else
              class="el-upload el-upload--car-two"
            >
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template
          slot-scope="scope"
          slot="wheelsImgsForm"
        >
          <el-upload
            :multiple="true"
            action="#"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList1"
            :http-request="fnUploadWheelsImgs"
            :show-file-list="false"
          >
            <div
              v-if="'' != wheelsImgs"
              class="el-upload el-upload--picture-img"
            >
              <div
                :key="wheelsImg.id"
                v-for="wheelsImg of wheelsImgs"
              >
                <img
                  :src="wheelsImg"
                  style="width: 200px;"
                />
                <a
                  style="margin-left: 20px"
                  @click.stop="deletePic(wheelsImg)"
                >删除</a>
              </div>
            </div>

            <div
              v-else
              class="el-upload el-upload--car-two"
            >
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { logOption } from "@/const/salesCloud/logOption";
import {
  addProductGoods,
  findProductGoodsById,
  productDown,
  productPutAway,
  updateProduct,
  findProductSkuClassify,
  findConstituteBySkuId,
  findBrand,
  chooseSecondClassify,
  findClassify
} from "@/api/salesCloud/log";
import {
  findCategoryAll,
  findItemsByCategory
} from "@/api/salesCloud/workOrder";
import { findCoupon } from "@/api/salesCloud/serviceCoupon";
import {
  findGoodsDetailList,
  findGoodsDetailSku,
  findGoodsDetailListDownload
} from "@/api/salesCloud/stockGoods";
import { DIC } from "@/const/dic";
import { excelaxios } from "@/util/excelaxios";
import { getCompany } from "@/util/auth";
import { exportExcel } from "xlsx-oc";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";

export default {
  name: "log",
  data() {
    return {
      tableOption: logOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      goodDetailId: "",
      page: {
        downloadData: {},
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      dialogTableVisible: false,
      grade: {
        box: false,
        check: []
      },
      productStatuses: DIC.PRODUCT_STATUS,
      brands: [],
      brand: {},
      classifies: [],
      classify: {},
      secondClassifies: [],
      secondClassify: {},
      departments: [],
      department: {},
      productStatus: "",
      dispatching: "EXPRESS",
      describeImgs: [],
      wheelsImg: "",
      wheelsImgs: [],
      fileList: [],
      fileList1: [],
      prices: [],
      clientTypes: DIC.CLIENT_TYPE,
      sku: {},
      skuList: [],
      tableData1: [],
      constitutes: [],
      dataSku1: [],
      joinsWorkServiceCategorys: [],
      joinsWorkServiceCategory: {},
      joinsWorkServiceItems: [],
      joinsWorkServiceItem: {},
      coupon: {},
      coupons: []
    };
  },
  created() {
    console.log(this);
    findBrand().then(res => {
      let data = JSON.parse(res.data);
      this.brands = data.rows;
    });
    findClassify().then(res => {
      let data = JSON.parse(res.data);
      this.classifies = data;
    });
    findCategoryAll().then(res => {
      let data = JSON.parse(res.data);
      this.joinsWorkServiceCategorys = data.rows;
    });
    // findAllSuperiorDepartment().then((res) => {
    //     let data = JSON.parse(res.data);
    //     this.departments = data
    // });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    deleteDes(describeImg) {
      console.log(describeImg);
      let index = this.describeImgs.indexOf(describeImg);
      if (index > -1) {
        this.describeImgs.splice(index, 1);
      }
    },
    deletePic(wheelsImg) {
      console.log(wheelsImg);
      let index = this.wheelsImgs.indexOf(wheelsImg);
      if (index > -1) {
        this.wheelsImgs.splice(index, 1);
      }
    },
    handleCell(scope) {
      this.dialogTableVisible = true;

      // console.log(row, index, this.dialogTableVisible);
      console.log(scope);
    },
    toLog() {
      this.$router.push({ path: "warehousing/log" });
    },
    handleAddRows() {
      console.log(this.constitutes);
      console.log(this.tableData1);
      let obj = "{";
      for (let i = 0; i < this.tableData1.length; i++) {
        if (i != this.tableData1.length - 1) {
          obj += "" + i + ":'',";
        } else {
          obj += "" + i + ":''";
        }
      }
      obj += "}";
      let dataObj = eval("(" + obj + ")");
      // console.log(dataObj)
      // let list = {
      //     price: '',
      //     goodsNumber:0,
      //     consumerDiscount:'',
      //     engineerDiscount:'',
      //     merchantDiscount:''
      // }
      this.constitutes.push(dataObj);
      console.log(this);
      // console.log(this.constitutes)
    },
    handleSteppingDelete(index) {
      // console.log(this.constitutes, 1111)
      this.constitutes.splice(index, 1);
      this.dataSku1.splice(index, 1);
      // console.log(this.dataSku1, 2222)
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findGoodsDetailList(this.goodDetailId, params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findGoodsDetailList(this.goodDetailId, params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      console.log(params);
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      // params.goodsName = this.$route.params.goodsName;
      params.name = params.createName ? params.createName : "";
      delete params.createName;
      this.downloadData = params;
      findGoodsDetailList(this.goodDetailId, params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      console.log(this);
      this.tableLoading = true;
      let id = this.goodDetailId;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      findGoodsDetailList(id, params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // console.log(this.describeImgs)
      this.prices = [];
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      console.log(row);
      this.clean();
      //一级分类回显
      this.classify.id = row.firstClassifyId;
      //二级分类回显
      chooseSecondClassify(this.classify.id).then(res => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
      });
      this.secondClassify.id = row.secondClassifyId;
      //sku组合回显
      let obj = {};
      obj.firstClassifyId = this.classify.id;
      obj.secondClassifyId = this.secondClassify.id;
      console.log(obj);
      findProductSkuClassify(obj).then(res => {
        let data = JSON.parse(res.data);
        this.skuList = data;
        this.sku.id = row.skuId;
        console.log(data);
        console.log(this.sku);
        console.log(this.skuList);
        //商品属性
        findConstituteBySkuId(this.sku.id).then(res => {
          let data = JSON.parse(res.data);
          this.formatConstitute(data);
          console.log(data);
        });
      });

      //商品详情回显
      let params = {
        goodsSkuId: row.goodsSkuId
      };
      findGoodsDetailSku(this.$route.params.id, params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        // this.wheelsImgs = data.wheelUrl;
        // this.describeImgs = data.describeUrl;
        //上架状态回显
        // this.productStatus = data.goodsStatus;
        console.log(typeof this.productStatus);
        //skulist回显
        console.log(data.goodsSkuList);
        let skuLenght = data.goodsSkuList[0].skuValue.split(":");
        skuLenght.push(data.goodsSkuList[0].primePrice + "");
        skuLenght.push(data.goodsSkuList[0].purchasePrice + "");
        skuLenght.push(data.goodsSkuList[0].retailPrice + "");
        skuLenght.push(data.goodsSkuList[0].stockNumber + "");
        console.log(skuLenght);
        let obj = Object.assign({}, skuLenght);
        console.log(obj);
        this.constitutes.push(obj);
      });
      // this.constitutes.push(row.properties)
      this.brand = row.brandId;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.goodDetailId = this.$route.params.id;
      let id = this.goodDetailId;
      console.log(this);
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findGoodsDetailList(id, params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      let dataSku = [];
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let strMap = new Map();
        for (let k of Object.keys(obj)) {
          strMap.set(k, obj[k]);
        }
        // console.log(strMap)
        let ids = "";
        let val = "";
        let skuMap = new Map();
        for (let j = 0; j < this.tableData1.length; j++) {
          let obj1 = this.tableData1[j];
          // console.log(obj1)
          if (typeof obj1.id != "undefined") {
            ids += obj1.id + ":";
            val += strMap.get(j + "") + ":";
          } else {
            skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
          }
        }
        let sku = Object.create(null);
        for (let [k, v] of skuMap) {
          sku[k] = v;
        }
        ids = ids.substring(0, ids.length - 1);
        val = val.substring(0, val.length - 1);
        sku.skuKey = ids;
        sku.skuValue = val;
        sku.skuId = this.sku.id;
        // console.log(sku)
        dataSku.push(sku);
      }
      // console.log(dataSku)
      row.dataSku = dataSku;
      row.brandId = this.brand.id;
      row.firstClassifyId = this.classify.id;
      row.secondClassifyId = this.secondClassify.id;
      row.productStatus = this.productStatus;
      row.dispatching = this.dispatching;
      row.agentId = this.department.dutyStuff;
      row.describeImgs = this.describeImgs;
      row.wheelsImgs = this.wheelsImgs;
      row.couponId = this.coupon.id;
      addProductGoods(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row);
      console.log(this);
      let params = {};
      let dataSku = [];
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let strMap = new Map();
        for (let k of Object.keys(obj)) {
          strMap.set(k, obj[k]);
        }
        // console.log(strMap)
        let ids = "";
        let val = "";
        let skuMap = new Map();
        for (let j = 0; j < this.tableData1.length; j++) {
          let obj1 = this.tableData1[j];
          // console.log(obj1)
          if (typeof obj1.id != "undefined") {
            ids += obj1.id + ":";
            val += strMap.get(j + "") + ":";
          } else {
            skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
          }
        }
        let sku = Object.create(null);
        for (let [k, v] of skuMap) {
          sku[k] = v;
        }
        ids = ids.substring(0, ids.length - 1);
        val = val.substring(0, val.length - 1);
        sku.skuKey = ids;
        sku.skuValue = val;
        sku.id = row.goodsSkuId;
        sku.skuId = this.sku.id;
        // console.log(sku)
        dataSku.push(sku);
      }
      params.id = row.id;
      params.name = row.name;
      params.goodsStatus = this.productStatus;
      params.unit = row.unit;
      params.skuId = this.sku.id ? this.sku.id : "";
      params.goodsSkuList = dataSku;
      params.brandId = this.brand ? this.brand : "";
      params.firstClassifyId = this.classify.id ? this.classify.id : "";
      params.secondClassifyId = this.secondClassify.id
        ? this.secondClassify.id
        : "";
      params.describeImgs = this.describeImgs;
      params.wheelsImgs = this.wheelsImgs;
      console.log(params);
      updateProduct(params)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    handleDetail(row, index) {
      this.constitutes = [];
      findProductGoodsById(row.id).then(res => {
        let data = JSON.parse(res.data);
        this.brand = { id: data.brandId };
        this.classify = { id: data.firstClassifyId };
        chooseSecondClassify(this.classify.id).then(res => {
          let data = JSON.parse(res.data);
          this.secondClassifies = data;
        });
        this.secondClassify = { id: data.secondClassifyId };
        this.findProductSkuClassify();
        this.sku = { id: data.skuId };
        this.formatConstitute(data.skuConstitute);
        this.dataSku1 = data.dataSku;
        for (let i = 0; i < data.dataSku.length; i++) {
          let mapObj = new Map();
          let dataSku = data.dataSku[i];
          let map = this.objToStrMap(dataSku);
          let arrayVal = map.get("skuValue").split(":");
          let tableData2 = this.tableData1;
          for (let j = 0; j < tableData2.length; j++) {
            let obj1 = tableData2[j];

            if (typeof obj1.id != "undefined") {
              mapObj.set(obj1.flag, arrayVal[obj1.flag]);
            } else {
              mapObj.set(obj1.flag, map.get(obj1.dataItem));
            }
          }

          this.constitutes.push(this.strMapToObj(mapObj));
        }
        // console.log(this.constitutes, 99999)
        this.department = { dutyStuff: data.agentId };
        this.describeImgs = data.describeImgs;
        if (this.describeImgs == null) {
          this.describeImgs = [];
        }

        this.wheelsImgs = data.wheelsImgs;
        if (this.wheelsImgs == null) {
          this.wheelsImgs = [];
        }
        this.productStatus = data.productStatus;
        this.dispatching = data.dispatching;
        // row.goodsNumber = data.goodsNumber
        // row.price = data.price
        // row.jdPrice = data.jdPrice
        row.consumerDiscount = data.consumerDiscount;
        row.engineerDiscount = data.engineerDiscount;
        row.merchantDiscount = data.merchantDiscount;
        // this.prices = row.prices
        this.$refs.crud.rowEdit(row, index);
      });
    },
    chooseSecondClassify() {
      console.log(this.classify);
      chooseSecondClassify(this.classify.id).then(res => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
        this.secondClassify = "";
        this.sku = "";
        this.constitutes = [];
        this.tableData1 = [];
      });
    },
    async fnUploadWheelsImgs(option) {
      if (this.wheelsImgs.length >= 5) {
        this.$message({
          showClose: true,
          message: "轮播图不能超过五张",
          type: "error"
        });
        return;
      }
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        // console.log(storeAs)
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.wheelsImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {
            // console.log(err);
          });
      });
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        // console.log(storeAs)
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.describeImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {
            // console.log(err);
          });
      });
    },
    productDown() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          productDown(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "下架成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    productPutAway() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认上架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          productPutAway(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "上架成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    singleProductPutAway(id) {
      this.$confirm(`是否确认上架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          productPutAway(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "上架成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    singleProductDown(id) {
      this.$confirm(`是否确认下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          productDown(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "下架成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    findProductSkuClassify() {
      let obj = {};
      obj.firstClassifyId = this.classify.id;
      obj.secondClassifyId = this.secondClassify.id;
      findProductSkuClassify(obj).then(res => {
        let data = JSON.parse(res.data);
        this.skuList = data;
        this.sku = "";
        this.constitutes = [];
        this.tableData1 = [];
      });
    },
    findConstituteBySkuId() {
      findConstituteBySkuId(this.sku.id).then(res => {
        let data = JSON.parse(res.data);
        this.formatConstitute(data);
      });
    },
    formatConstitute(data) {
      let flag = 0;
      this.tableData1 = new Array(data.length + 4);
      for (let i = 0; i < data.length; i++) {
        let obj = {};
        obj.dataItem = data[i].constituteCode;
        obj.dataName = data[i].constituteName;
        obj.placeholder = data[i].constituteName;
        obj.id = data[i].id;
        obj.flag = flag;
        this.tableData1[flag] = obj;
        //this.tableData1.push(obj)
        flag++;
      }
      this.tableData1[flag] = {
        dataItem: "primePrice",
        dataName: "进货价",
        placeholder: "进货价",
        flag: flag
      };
      this.tableData1[flag + 1] = {
        dataItem: "purchasePrice",
        dataName: "采购价",
        placeholder: "采购价",
        flag: flag + 1
      };
      this.tableData1[flag + 2] = {
        dataItem: "retailPrice",
        dataName: "零售价",
        placeholder: "零售价",
        flag: flag + 2
      };
      this.tableData1[flag + 3] = {
        dataItem: "stockNumber",
        dataName: "入库量",
        placeholder: "入库量",
        flag: flag + 3
      };
      // this.tableData1[flag + 4] = {
      //   dataItem: "merchantDiscount",
      //   dataName: "商家折扣",
      //   placeholder: "商家折扣",
      //   flag: flag + 4
      // };
      console.log(this);
    },
    objToStrMap(obj) {
      let strMap = new Map();
      for (let k of Object.keys(obj)) {
        strMap.set(k, obj[k]);
      }
      return strMap;
    },
    strMapToObj(strMap) {
      let obj = Object.create(null);
      for (let [k, v] of strMap) {
        obj[k] = v;
      }
      return obj;
    },
    choseWorkServiceItem() {
      findItemsByCategory(this.joinsWorkServiceCategory.id).then(res => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
      });
    },
    findCoupon() {
      let obj = {};
      obj.serviceCategoryId = this.joinsWorkServiceCategory.id;
      obj.serviceItemId = this.joinsWorkServiceItem.id;
      findCoupon(obj).then(res => {
        let data = JSON.parse(res.data);
        this.coupons = data;
      });
    },
    clean() {
      this.brand = {};
      this.classify = {};
      this.secondClassify = {};
      this.sku = {};
      this.constitutes = [];
      this.joinsWorkServiceCategory = {};
      this.joinsWorkServiceItem = {};
      this.coupon = {};
      this.skuList = [];
      this.tableData1 = [];
      this.constitutes = [];
      this.dataSku1 = [];
      this.describeImgs = [];
      this.wheelsImgs = [];
    },
    downloadExcelLog() {
      let params = this.downloadData;
      findGoodsDetailListDownload(this.goodDetailId, params).then(res => {
        window.open(res);
      });
      // let url = `/joins-sales-cloud/v1/shop_goods/exportGoodsDetail?`;
      // let params = {};
      // params.name = "";
      // params = this.downloadData;
      // console.log(params);
      // console.log(this.$route.params.id);
      // params.goodsName = this.$route.params.id;
      // excelaxios(url, params);
      // let params = this.downloadData;
      // delete params.page;
      // params.size = this.page.total;
      // let id = this.goodDetailId;
      // findGoodsDetailList(id, params).then(res => {
      //   let data = JSON.parse(res.data);
      //   let list = data.rows;
      //   list = list.map(item => {
      //     let properties = "";
      //     for (let i of item.properties) {
      //       properties += i.skuKey + ":" + i.skuValue;
      //     }
      //     item.stockTime = formatterDateToUTC(item.stockTime);
      //     item.properties = properties;
      //     return item;
      //   });
      //   for (let i of list) {
      //     i.chooseClientType = parseStatus(
      //       DIC.WALLET_USER_TYPE,
      //       i.chooseClientType
      //     );
      //     i.clientType = parseStatus(DIC.WALLET_USER_TYPE, i.clientType);
      //     i.rechargeWay = parseStatus(DIC.WALLET_RECHARGE_WAY, i.rechargeWay);
      //     i.createTime = formatterDateToUTC(i.createTime * 1);
      //     i.mobile = i.mobile == null ? "" : i.mobile;
      //     i.realName = i.realName == null ? "" : i.realName;
      //     i.amount = i.amount == null ? "" : i.amount;
      //   }
      //   const header = [];
      //   for (let i of this.tableOption.column) {
      //     const obj = {};
      //     if (
      //       i.prop == "sku" ||
      //       i.prop == "productStatus" ||
      //       i.prop == "constitute" ||
      //       i.prop == "describeImgs" ||
      //       i.prop == "startDate_endDate" ||
      //       i.prop == "wheelsImgs"
      //     ) {
      //       ("");
      //     } else {
      //       obj.k = i.prop;
      //       obj.v = i.label;
      //       header.push(obj);
      //     }
      //   }
      //   const fileName = "商品入库记录.xlsx";
      //   exportExcel(header, list, fileName);
      // });
    },
    printJson() {
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      let id = this.goodDetailId;
      findGoodsDetailList(id, params).then(res => {
        this.tableLoading = true;
        let data = JSON.parse(res.data);
        console.log(data.rows);
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map(item => {
          // console.log(item.properties);
          // let properties = "";
          // for (let i of item.properties) {
          //   properties += i.skuKey + ":" + i.skuValue;
          // }
          // console.log(properties);
          item.createTime = formatterDateToUTC(item.createTime);
          // item.properties = properties;
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "name", displayName: "商品名称" },
            { field: "unit", displayName: "商品单位" },
            { field: "stockPrice", displayName: "进货价格" },
            { field: "purchasePrice", displayName: "采购价格" },
            { field: "salePrice", displayName: "零售价格" },
            { field: "brandName", displayName: "品牌名称" },
            { field: "firstClassifyName", displayName: "一级分类" },
            { field: "secondClassifyName", displayName: "二级分类" },
            { field: "properties", displayName: "商品属性" },
            { field: "amount", displayName: "入库量" },
            { field: "createTime", displayName: "入库时间" },
            { field: "createBy", displayName: "入库人" }
          ],
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center",
          type: "json"
        });
      });
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
